import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const base = `${u}/comments`;

export const getComments = (entityType, entityId) =>
  apiFetch(`${base}/${entityType}/${entityId}`).then(r => r.ok ? r.json() : Promise.reject(r));

export const addComment = (entityType, entityId, content) =>
  apiFetch(`${base}/${entityType}/${entityId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content })
  }).then(r => r.ok ? r.json() : Promise.reject(r));

export const updateComment = (commentId, content) =>
  apiFetch(`${base}/${commentId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content })
  }).then(r => r.ok ? r.json() : Promise.reject(r));

export const deleteComment = (commentId) =>
  apiFetch(`${base}/${commentId}`, { method: "DELETE" });
